// Ventas completadas del SKU en el periodo, ya como renglones; la misma caché para «Stock y movimientos» y «Ventas».
import { useMemo } from 'react';
import type { InventoryLensPeriod } from '@/api/services/retail-catalog/backoffice';
import { skuSalesFilters, toSkuSaleRow, type SkuSaleRow } from '../lib/inventoryDetail';
import type { InventoryRow } from '../lib/inventoryList';
import { useSkuSales } from './useInventorySku';

export interface SkuSalesContext {
    period: InventoryLensPeriod;
    storeId: string | undefined;
    retailerId: string | null;
    today: string;
}

/** Sin cadena o en tarjeta PCF no hay filtros: la consulta queda apagada y `available` en falso. */
export function useSkuSaleRows(row: InventoryRow, ctx: SkuSalesContext, enabled: boolean) {
    const filters =
        row.kind === 'CARD' || ctx.retailerId === null
            ? null
            : skuSalesFilters(ctx.retailerId, row.sku, ctx.period, ctx.storeId, ctx.today);
    const query = useSkuSales(filters, enabled);
    const rows = useMemo<SkuSaleRow[]>(
        () =>
            (query.data?.pages ?? []).flatMap((p) => p.items.map((s) => toSkuSaleRow(s, row.sku))),
        [query.data, row.sku],
    );
    return { query, rows, available: filters !== null };
}
